export const ds_QuoteLayoutBlock_Entry = `
    fragment ds_QuoteLayoutBlock_Entry on ds_QuoteLayoutBlock_Entry {
        id
        canonicalUid

        quote_QuoteItems {
            ... on ds_QuoteItem_Entry {
                quoteItem_Text
                quoteItem_Image {
                    url @transform(width: 48, height: 48)
                    id
                    focalPoint
                    alt
                }
                quoteItem_Graphic
                quoteItem_AuthorName
                quoteItem_AuthorDetail
                quoteItem_Icon {
                    set
                    name
                    type
                }
            }
        }

        quote_TextSize
        quote_Alignment
        quote_Padding

        quote_ColorPalette
        quote_ColorTheme
    }
`
